/* tslint:disable */
/* eslint-disable */
/**
 * Digimuth.Talemax.Dashboard.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ApplicationUserActivationDto
 */
export interface ApplicationUserActivationDto {
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserActivationDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserActivationDto
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserActivationDto
     */
    token?: string | null;
}
/**
 * 
 * @export
 * @interface ApplicationUserCassetteMappingDto
 */
export interface ApplicationUserCassetteMappingDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserCassetteMappingDto
     */
    containerKey?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserCassetteMappingDto
     */
    denomination?: string | null;
}
/**
 * 
 * @export
 * @interface ApplicationUserCassetteMappingsDto
 */
export interface ApplicationUserCassetteMappingsDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserCassetteMappingsDto
     */
    applicationUserId?: number;
    /**
     * 
     * @type {Array<ApplicationUserCassetteMappingDto>}
     * @memberof ApplicationUserCassetteMappingsDto
     */
    cassetteMappings?: Array<ApplicationUserCassetteMappingDto> | null;
}
/**
 * 
 * @export
 * @interface ApplicationUserDetailsDto
 */
export interface ApplicationUserDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDetailsDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDetailsDto
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserDetailsDto
     */
    emailConfirmed?: boolean;
    /**
     * 
     * @type {Array<ApplicationUserRole>}
     * @memberof ApplicationUserDetailsDto
     */
    roles?: Array<ApplicationUserRole> | null;
    /**
     * 
     * @type {ApplicationUserRole}
     * @memberof ApplicationUserDetailsDto
     */
    role?: ApplicationUserRole;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserDetailsDto
     */
    canReadTransactions?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApplicationUserDetailsDto
     */
    availableDevicesIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApplicationUserDetailsDto
     */
    emailAddressesList?: Array<string> | null;
    /**
     * 
     * @type {DeviceInactivityConfigurationDto}
     * @memberof ApplicationUserDetailsDto
     */
    deviceInactivityConfiguration?: DeviceInactivityConfigurationDto;
    /**
     * 
     * @type {LmConfigurationDto}
     * @memberof ApplicationUserDetailsDto
     */
    lmConfiguration?: LmConfigurationDto;
    /**
     * 
     * @type {ReportingUserConnectionDto}
     * @memberof ApplicationUserDetailsDto
     */
    reportingUserConnection?: ReportingUserConnectionDto;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserDetailsDto
     */
    sendMailAfterCashRemoval?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserDetailsDto
     */
    sendMailAfterCashRemovalWithoutOverfill?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserDetailsDto
     */
    transactionsAutoRemove?: boolean;
    /**
     * 
     * @type {CassetteFillingConfigurationDto}
     * @memberof ApplicationUserDetailsDto
     */
    cassetteFillingConfiguration?: CassetteFillingConfigurationDto;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDetailsDto
     */
    address?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserDetailsDto
     */
    autoLogout?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserDetailsDto
     */
    reportTransactions?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDetailsDto
     */
    reportTransactionsFrom?: string | null;
}
/**
 * 
 * @export
 * @interface ApplicationUserDto
 */
export interface ApplicationUserDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDto
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserDto
     */
    emailConfirmed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserDto
     */
    autoLogout?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserDto
     */
    canReadTransactions?: boolean;
    /**
     * 
     * @type {Array<ApplicationUserRole>}
     * @memberof ApplicationUserDto
     */
    roles?: Array<ApplicationUserRole> | null;
    /**
     * 
     * @type {ApplicationUserRole}
     * @memberof ApplicationUserDto
     */
    role?: ApplicationUserRole;
}
/**
 * 
 * @export
 * @interface ApplicationUserMinimalDto
 */
export interface ApplicationUserMinimalDto {
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserMinimalDto
     */
    userName?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApplicationUserMinimalDto
     */
    availableDevicesIds?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ApplicationUserRegisterDto
 */
export interface ApplicationUserRegisterDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserRegisterDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserRegisterDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserRegisterDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserRegisterDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserRegisterDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserRegisterDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserRegisterDto
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserRegisterDto
     */
    emailConfirmed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserRegisterDto
     */
    password?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserRegisterDto
     */
    withInvitation?: boolean;
    /**
     * 
     * @type {ApplicationUserRole}
     * @memberof ApplicationUserRegisterDto
     */
    role?: ApplicationUserRole;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserRegisterDto
     */
    canReadTransactions?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApplicationUserRegisterDto
     */
    availableDevicesIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApplicationUserRegisterDto
     */
    emailAddressesList?: Array<string> | null;
    /**
     * 
     * @type {DeviceInactivityConfigurationDto}
     * @memberof ApplicationUserRegisterDto
     */
    deviceInactivityConfiguration?: DeviceInactivityConfigurationDto;
    /**
     * 
     * @type {LmConfigurationDto}
     * @memberof ApplicationUserRegisterDto
     */
    lmConfiguration?: LmConfigurationDto;
    /**
     * 
     * @type {ReportingUserConnectionDto}
     * @memberof ApplicationUserRegisterDto
     */
    reportingUserConnection?: ReportingUserConnectionDto;
    /**
     * 
     * @type {CassetteFillingConfigurationDto}
     * @memberof ApplicationUserRegisterDto
     */
    cassetteFillingConfiguration?: CassetteFillingConfigurationDto;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserRegisterDto
     */
    sendMailAfterCashRemoval?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserRegisterDto
     */
    sendMailAfterCashRemovalWithoutOverfill?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserRegisterDto
     */
    transactionsAutoRemove?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserRegisterDto
     */
    address?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserRegisterDto
     */
    autoLogout?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserRegisterDto
     */
    reportTransactions?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserRegisterDto
     */
    reportTransactionsFrom?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ApplicationUserRole {
    Admin = 'Admin',
    ReportingSoftware = 'ReportingSoftware',
    Readonly = 'Readonly',
    DeviceAdmin = 'DeviceAdmin',
    LmItSupport = 'LmItSupport'
}

/**
 * 
 * @export
 * @interface CassetteContentDto
 */
export interface CassetteContentDto {
    /**
     * 
     * @type {number}
     * @memberof CassetteContentDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CassetteContentDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CassetteContentDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CassetteContentDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CassetteContentDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CassetteContentDto
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof CassetteContentDto
     */
    fillLevel?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof CassetteContentDto
     */
    sum?: { [key: string]: number; } | null;
    /**
     * 
     * @type {Array<DenominationInfoDto>}
     * @memberof CassetteContentDto
     */
    denominationDetails?: Array<DenominationInfoDto> | null;
}
/**
 * 
 * @export
 * @interface CassetteFillingConfigurationDto
 */
export interface CassetteFillingConfigurationDto {
    /**
     * 
     * @type {number}
     * @memberof CassetteFillingConfigurationDto
     */
    cassetteFilling?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CassetteFillingConfigurationDto
     */
    notificationsEnabled?: boolean;
}
/**
 * 
 * @export
 * @interface ConfigurationDto
 */
export interface ConfigurationDto {
    /**
     * 
     * @type {string}
     * @memberof ConfigurationDto
     */
    configuration?: string | null;
}
/**
 * 
 * @export
 * @interface DenominationInfoDto
 */
export interface DenominationInfoDto {
    /**
     * 
     * @type {number}
     * @memberof DenominationInfoDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof DenominationInfoDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof DenominationInfoDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof DenominationInfoDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DenominationInfoDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DenominationInfoDto
     */
    nominalValue?: number;
    /**
     * 
     * @type {number}
     * @memberof DenominationInfoDto
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof DenominationInfoDto
     */
    currency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DenominationInfoDto
     */
    type?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DenominationInfoDto
     */
    containerNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof DenominationInfoDto
     */
    direction?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DenominationInfoDto
     */
    fits?: number;
    /**
     * 
     * @type {string}
     * @memberof DenominationInfoDto
     */
    unfits?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DenominationInfoDto
     */
    suspicious?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DenominationInfoDto
     */
    counterFits?: string | null;
}
/**
 * 
 * @export
 * @interface DeviceHistoryEventDto
 */
export interface DeviceHistoryEventDto {
    /**
     * 
     * @type {number}
     * @memberof DeviceHistoryEventDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof DeviceHistoryEventDto
     */
    kind?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceHistoryEventDto
     */
    occurredAt?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceHistoryEventDto
     */
    transactionType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceHistoryEventDto
     */
    direction?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DeviceHistoryEventDto
     */
    amount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceHistoryEventDto
     */
    currency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceHistoryEventDto
     */
    transactionTypes?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DeviceHistoryEventDto
     */
    responseStatusCode?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceHistoryEventDto
     */
    isSuccessful?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceHistoryEventDto
     */
    isConnected?: boolean | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum DeviceInactivity {
    Saturday = 'Saturday',
    Sunday = 'Sunday',
    Weekend = 'Weekend',
    None = 'None'
}

/**
 * 
 * @export
 * @interface DeviceInactivityConfigurationDto
 */
export interface DeviceInactivityConfigurationDto {
    /**
     * 
     * @type {boolean}
     * @memberof DeviceInactivityConfigurationDto
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DeviceInactivityConfigurationDto
     */
    from?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceInactivityConfigurationDto
     */
    to?: string | null;
    /**
     * 
     * @type {DeviceInactivity}
     * @memberof DeviceInactivityConfigurationDto
     */
    inactivityDays?: DeviceInactivity;
}
/**
 * 
 * @export
 * @interface DeviceSummaryDto
 */
export interface DeviceSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof DeviceSummaryDto
     */
    allDevices?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceSummaryDto
     */
    onlineDeviceCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceSummaryDto
     */
    offlineDeviceCount?: number;
}
/**
 * 
 * @export
 * @interface EndForgotPasswordDto
 */
export interface EndForgotPasswordDto {
    /**
     * 
     * @type {string}
     * @memberof EndForgotPasswordDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EndForgotPasswordDto
     */
    token?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EndForgotPasswordDto
     */
    newPassword?: string | null;
}
/**
 * 
 * @export
 * @interface LmCommunicationConfigurationDto
 */
export interface LmCommunicationConfigurationDto {
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationConfigurationDto
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationConfigurationDto
     */
    apiKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationConfigurationDto
     */
    serverIp?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationConfigurationDto
     */
    stocktakingUserId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LmCommunicationConfigurationDto
     */
    starterAmount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof LmCommunicationConfigurationDto
     */
    lmDevices?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface LmCommunicationHistoryDetailsDto
 */
export interface LmCommunicationHistoryDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof LmCommunicationHistoryDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationHistoryDetailsDto
     */
    environment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LmCommunicationHistoryDetailsDto
     */
    reportingUserId?: number;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationHistoryDetailsDto
     */
    sentAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationHistoryDetailsDto
     */
    resentAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LmCommunicationHistoryDetailsDto
     */
    transactionId?: number;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationHistoryDetailsDto
     */
    deviceName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationHistoryDetailsDto
     */
    transactionTypes?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LmCommunicationHistoryDetailsDto
     */
    responseStatusCode?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LmCommunicationHistoryDetailsDto
     */
    durationMilliseconds?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof LmCommunicationHistoryDetailsDto
     */
    isSuccessful?: boolean;
    /**
     * 
     * @type {TransactionDto}
     * @memberof LmCommunicationHistoryDetailsDto
     */
    transaction?: TransactionDto;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationHistoryDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationHistoryDetailsDto
     */
    resendAttemptedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LmCommunicationHistoryDetailsDto
     */
    resentById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LmCommunicationHistoryDetailsDto
     */
    automaticResendAttempts?: number;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationHistoryDetailsDto
     */
    resentByEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationHistoryDetailsDto
     */
    destinationUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationHistoryDetailsDto
     */
    requestPayload?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationHistoryDetailsDto
     */
    operation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationHistoryDetailsDto
     */
    responseBody?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationHistoryDetailsDto
     */
    errorMessage?: string | null;
}
/**
 * 
 * @export
 * @interface LmCommunicationHistoryDto
 */
export interface LmCommunicationHistoryDto {
    /**
     * 
     * @type {number}
     * @memberof LmCommunicationHistoryDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationHistoryDto
     */
    environment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LmCommunicationHistoryDto
     */
    reportingUserId?: number;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationHistoryDto
     */
    sentAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationHistoryDto
     */
    resentAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LmCommunicationHistoryDto
     */
    transactionId?: number;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationHistoryDto
     */
    deviceName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationHistoryDto
     */
    transactionTypes?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LmCommunicationHistoryDto
     */
    responseStatusCode?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LmCommunicationHistoryDto
     */
    durationMilliseconds?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof LmCommunicationHistoryDto
     */
    isSuccessful?: boolean;
}
/**
 * 
 * @export
 * @interface LmCommunicationSettingsDto
 */
export interface LmCommunicationSettingsDto {
    /**
     * 
     * @type {number}
     * @memberof LmCommunicationSettingsDto
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LmCommunicationSettingsDto
     */
    isEnabled?: boolean;
}
/**
 * 
 * @export
 * @interface LmCommunicationSettingsHistoryDto
 */
export interface LmCommunicationSettingsHistoryDto {
    /**
     * 
     * @type {boolean}
     * @memberof LmCommunicationSettingsHistoryDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationSettingsHistoryDto
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof LmCommunicationSettingsHistoryDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationSettingsHistoryDto
     */
    updatedByUserName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationSettingsHistoryDto
     */
    message?: string | null;
}
/**
 * 
 * @export
 * @interface LmCommunicationSettingsUpdateDto
 */
export interface LmCommunicationSettingsUpdateDto {
    /**
     * 
     * @type {boolean}
     * @memberof LmCommunicationSettingsUpdateDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LmCommunicationSettingsUpdateDto
     */
    message?: string | null;
}
/**
 * 
 * @export
 * @interface LmConfigurationDto
 */
export interface LmConfigurationDto {
    /**
     * 
     * @type {string}
     * @memberof LmConfigurationDto
     */
    deviceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LmConfigurationDto
     */
    storeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LmConfigurationDto
     */
    safeVendor?: string | null;
}
/**
 * 
 * @export
 * @interface LmReportSummaryDto
 */
export interface LmReportSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof LmReportSummaryDto
     */
    allReports?: number;
    /**
     * 
     * @type {number}
     * @memberof LmReportSummaryDto
     */
    successfulReports?: number;
    /**
     * 
     * @type {number}
     * @memberof LmReportSummaryDto
     */
    failedReports?: number;
}
/**
 * 
 * @export
 * @interface LmServerAvailabilityDto
 */
export interface LmServerAvailabilityDto {
    /**
     * 
     * @type {boolean}
     * @memberof LmServerAvailabilityDto
     */
    isAvailable?: boolean;
}
/**
 * 
 * @export
 * @interface LogDetailsDto
 */
export interface LogDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof LogDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof LogDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof LogDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof LogDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LogDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LogDetailsDto
     */
    logFileContent?: string | null;
}
/**
 * 
 * @export
 * @interface LogDto
 */
export interface LogDto {
    /**
     * 
     * @type {number}
     * @memberof LogDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof LogDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof LogDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof LogDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LogDto
     */
    updatedById?: number | null;
}
/**
 * 
 * @export
 * @interface LoginDto
 */
export interface LoginDto {
    /**
     * 
     * @type {string}
     * @memberof LoginDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginDto
     */
    password?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LoginDto
     */
    rememberMe?: boolean;
}
/**
 * 
 * @export
 * @interface ManualTransactionUploadDto
 */
export interface ManualTransactionUploadDto {
    /**
     * 
     * @type {string}
     * @memberof ManualTransactionUploadDto
     */
    fileContent?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum OperationType {
    Add = 'Add',
    Remove = 'Remove',
    Replace = 'Replace',
    Move = 'Move',
    Copy = 'Copy',
    Test = 'Test',
    Invalid = 'Invalid'
}

/**
 * 
 * @export
 * @interface ReportingUserConnectionDto
 */
export interface ReportingUserConnectionDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ReportingUserConnectionDto
     */
    offlineNotifyEmails?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserConnectionDto
     */
    offlineNotifySentAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportingUserConnectionDto
     */
    maxOfflineTime?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReportingUserConnectionDto
     */
    checkDeviceConnection?: boolean;
}
/**
 * 
 * @export
 * @interface ReportingUserDepositReportDto
 */
export interface ReportingUserDepositReportDto {
    /**
     * 
     * @type {number}
     * @memberof ReportingUserDepositReportDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDepositReportDto
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDepositReportDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDepositReportDto
     */
    depositDate?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportingUserDepositReportDto
     */
    sum?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDepositReportDto
     */
    currency?: string | null;
}
/**
 * 
 * @export
 * @interface ReportingUserDetailsDto
 */
export interface ReportingUserDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ReportingUserDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportingUserDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportingUserDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDetailsDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDetailsDto
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReportingUserDetailsDto
     */
    emailConfirmed?: boolean;
    /**
     * 
     * @type {Array<ApplicationUserRole>}
     * @memberof ReportingUserDetailsDto
     */
    roles?: Array<ApplicationUserRole> | null;
    /**
     * 
     * @type {DeviceInactivityConfigurationDto}
     * @memberof ReportingUserDetailsDto
     */
    deviceInactivityConfiguration?: DeviceInactivityConfigurationDto;
    /**
     * 
     * @type {boolean}
     * @memberof ReportingUserDetailsDto
     */
    transactionsAutoRemove?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReportingUserDetailsDto
     */
    reportTransactions?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDetailsDto
     */
    reportTransactionsFrom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDetailsDto
     */
    password?: string | null;
    /**
     * 
     * @type {Array<TransactionWithCassetteDetailsDto>}
     * @memberof ReportingUserDetailsDto
     */
    transactions?: Array<TransactionWithCassetteDetailsDto> | null;
}
/**
 * 
 * @export
 * @interface ReportingUserDetailsReducedDto
 */
export interface ReportingUserDetailsReducedDto {
    /**
     * 
     * @type {number}
     * @memberof ReportingUserDetailsReducedDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDetailsReducedDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportingUserDetailsReducedDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDetailsReducedDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportingUserDetailsReducedDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDetailsReducedDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDetailsReducedDto
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReportingUserDetailsReducedDto
     */
    emailConfirmed?: boolean;
    /**
     * 
     * @type {Array<CassetteContentDto>}
     * @memberof ReportingUserDetailsReducedDto
     */
    lastTransactionCassetteContent?: Array<CassetteContentDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDetailsReducedDto
     */
    configuration?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDetailsReducedDto
     */
    inactivityMailSentAt?: string | null;
    /**
     * 
     * @type {DeviceInactivityConfigurationDto}
     * @memberof ReportingUserDetailsReducedDto
     */
    deviceInactivityConfiguration?: DeviceInactivityConfigurationDto;
    /**
     * 
     * @type {LmConfigurationDto}
     * @memberof ReportingUserDetailsReducedDto
     */
    lmConfiguration?: LmConfigurationDto;
    /**
     * 
     * @type {ReportingUserStateDto}
     * @memberof ReportingUserDetailsReducedDto
     */
    reportingUserState?: ReportingUserStateDto;
    /**
     * 
     * @type {ReportingUserConnectionDto}
     * @memberof ReportingUserDetailsReducedDto
     */
    reportingUserConnection?: ReportingUserConnectionDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReportingUserDetailsReducedDto
     */
    emailAddressesList?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDetailsReducedDto
     */
    overfillTime?: string | null;
    /**
     * 
     * @type {CassetteFillingConfigurationDto}
     * @memberof ReportingUserDetailsReducedDto
     */
    cassetteFillingConfiguration?: CassetteFillingConfigurationDto;
    /**
     * 
     * @type {boolean}
     * @memberof ReportingUserDetailsReducedDto
     */
    reportTransactions?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDetailsReducedDto
     */
    reportTransactionsFrom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDetailsReducedDto
     */
    lastTransactionDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDetailsReducedDto
     */
    address?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportingUserDetailsReducedDto
     */
    averageFillLevel?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReportingUserDetailsReducedDto
     */
    transactionsAutoRemove?: boolean;
}
/**
 * 
 * @export
 * @interface ReportingUserDto
 */
export interface ReportingUserDto {
    /**
     * 
     * @type {number}
     * @memberof ReportingUserDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportingUserDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportingUserDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDto
     */
    userName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportingUserDto
     */
    averageFillLevel?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReportingUserDto
     */
    sendMailAfterCashRemoval?: boolean;
    /**
     * 
     * @type {ReportingUserStateDto}
     * @memberof ReportingUserDto
     */
    reportingUserState?: ReportingUserStateDto;
    /**
     * 
     * @type {ReportingUserConnectionDto}
     * @memberof ReportingUserDto
     */
    reportingUserConnection?: ReportingUserConnectionDto;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDto
     */
    lastTransactionDate?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReportingUserDto
     */
    reportTransactions?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserDto
     */
    reportTransactionsFrom?: string | null;
}
/**
 * 
 * @export
 * @interface ReportingUserRegisterDto
 */
export interface ReportingUserRegisterDto {
    /**
     * 
     * @type {number}
     * @memberof ReportingUserRegisterDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserRegisterDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportingUserRegisterDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserRegisterDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportingUserRegisterDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserRegisterDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserRegisterDto
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReportingUserRegisterDto
     */
    emailConfirmed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserRegisterDto
     */
    password?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReportingUserRegisterDto
     */
    withInvitation?: boolean;
    /**
     * 
     * @type {ApplicationUserRole}
     * @memberof ReportingUserRegisterDto
     */
    role?: ApplicationUserRole;
    /**
     * 
     * @type {CassetteFillingConfigurationDto}
     * @memberof ReportingUserRegisterDto
     */
    cassetteFillingConfiguration?: CassetteFillingConfigurationDto;
    /**
     * 
     * @type {DeviceInactivityConfigurationDto}
     * @memberof ReportingUserRegisterDto
     */
    deviceInactivityConfiguration?: DeviceInactivityConfigurationDto;
    /**
     * 
     * @type {LmConfigurationDto}
     * @memberof ReportingUserRegisterDto
     */
    lmConfiguration?: LmConfigurationDto;
    /**
     * 
     * @type {ReportingUserConnectionDto}
     * @memberof ReportingUserRegisterDto
     */
    reportingUserConnection?: ReportingUserConnectionDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReportingUserRegisterDto
     */
    emailAddressesList?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReportingUserRegisterDto
     */
    sendMailAfterCashRemoval?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReportingUserRegisterDto
     */
    sendMailAfterCashRemovalWithoutOverfill?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReportingUserRegisterDto
     */
    transactionsAutoRemove?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReportingUserRegisterDto
     */
    reportTransactions?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserRegisterDto
     */
    reportTransactionsFrom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserRegisterDto
     */
    address?: string | null;
}
/**
 * 
 * @export
 * @interface ReportingUserStateDto
 */
export interface ReportingUserStateDto {
    /**
     * 
     * @type {string}
     * @memberof ReportingUserStateDto
     */
    connectionId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserStateDto
     */
    connectedAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportingUserStateDto
     */
    disconnectedAt?: string | null;
}
/**
 * 
 * @export
 * @interface StartForgotPasswordDto
 */
export interface StartForgotPasswordDto {
    /**
     * 
     * @type {string}
     * @memberof StartForgotPasswordDto
     */
    email?: string | null;
}
/**
 * 
 * @export
 * @interface SummaryDto
 */
export interface SummaryDto {
    /**
     * 
     * @type {LmReportSummaryDto}
     * @memberof SummaryDto
     */
    lmReportSummary?: LmReportSummaryDto;
    /**
     * 
     * @type {TransactionSummaryDto}
     * @memberof SummaryDto
     */
    transactionSummary?: TransactionSummaryDto;
    /**
     * 
     * @type {DeviceSummaryDto}
     * @memberof SummaryDto
     */
    deviceSummary?: DeviceSummaryDto;
}
/**
 * 
 * @export
 * @interface TransactionCashRemovalReportDto
 */
export interface TransactionCashRemovalReportDto {
    /**
     * 
     * @type {number}
     * @memberof TransactionCashRemovalReportDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionCashRemovalReportDto
     */
    parentTransactionId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionCashRemovalReportDto
     */
    number?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransactionCashRemovalReportDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionCashRemovalReportDto
     */
    previousTransactionType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionCashRemovalReportDto
     */
    currency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionCashRemovalReportDto
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionCashRemovalReportDto
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionCashRemovalReportDto
     */
    bag?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionCashRemovalReportDto
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionCashRemovalReportDto
     */
    reportedByUserId?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionCashRemovalReportDto
     */
    containerNumber?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionCashRemovalReportDto
     */
    reportedByUsername?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransactionCashRemovalReportDto
     */
    fillLevel?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionCashRemovalReportDto
     */
    overfillNotificationTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionCashRemovalReportDto
     */
    timeFromOverfillToRemoval?: string | null;
}
/**
 * 
 * @export
 * @interface TransactionCreateDto
 */
export interface TransactionCreateDto {
    /**
     * 
     * @type {number}
     * @memberof TransactionCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransactionCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionCreateDto
     */
    number?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransactionCreateDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionCreateDto
     */
    currency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionCreateDto
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionCreateDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionCreateDto
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionCreateDto
     */
    method?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionCreateDto
     */
    direction?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionCreateDto
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionCreateDto
     */
    reportedByUserId?: number;
    /**
     * 
     * @type {ApplicationUserMinimalDto}
     * @memberof TransactionCreateDto
     */
    reportedByUser?: ApplicationUserMinimalDto;
    /**
     * 
     * @type {TransactionDto}
     * @memberof TransactionCreateDto
     */
    parentTransaction?: TransactionDto;
    /**
     * 
     * @type {number}
     * @memberof TransactionCreateDto
     */
    parentTransactionId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionCreateDto
     */
    bag?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionCreateDto
     */
    originalFileContents?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransactionCreateDto
     */
    depositAmount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionCreateDto
     */
    overfillNotificationTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionCreateDto
     */
    timeFromOverfillToRemoval?: string | null;
    /**
     * 
     * @type {Array<DenominationInfoDto>}
     * @memberof TransactionCreateDto
     */
    denominationDetails?: Array<DenominationInfoDto> | null;
    /**
     * 
     * @type {Array<CassetteContentDto>}
     * @memberof TransactionCreateDto
     */
    cassetteContents?: Array<CassetteContentDto> | null;
}
/**
 * 
 * @export
 * @interface TransactionDetailsDto
 */
export interface TransactionDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof TransactionDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransactionDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetailsDto
     */
    number?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransactionDetailsDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetailsDto
     */
    currency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetailsDto
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetailsDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetailsDto
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetailsDto
     */
    method?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetailsDto
     */
    direction?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetailsDto
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionDetailsDto
     */
    reportedByUserId?: number;
    /**
     * 
     * @type {ApplicationUserMinimalDto}
     * @memberof TransactionDetailsDto
     */
    reportedByUser?: ApplicationUserMinimalDto;
    /**
     * 
     * @type {TransactionDto}
     * @memberof TransactionDetailsDto
     */
    parentTransaction?: TransactionDto;
    /**
     * 
     * @type {number}
     * @memberof TransactionDetailsDto
     */
    parentTransactionId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetailsDto
     */
    bag?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransactionDetailsDto
     */
    depositAmount?: number | null;
    /**
     * 
     * @type {Array<DenominationInfoDto>}
     * @memberof TransactionDetailsDto
     */
    denominationDetails?: Array<DenominationInfoDto> | null;
    /**
     * 
     * @type {Array<CassetteContentDto>}
     * @memberof TransactionDetailsDto
     */
    cassetteContents?: Array<CassetteContentDto> | null;
    /**
     * 
     * @type {Array<CassetteContentDto>}
     * @memberof TransactionDetailsDto
     */
    cassetteContentsBefore?: Array<CassetteContentDto> | null;
    /**
     * 
     * @type {Array<TransactionDto>}
     * @memberof TransactionDetailsDto
     */
    transactions?: Array<TransactionDto> | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetailsDto
     */
    overfillNotificationTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionDetailsDto
     */
    timeFromOverfillToRemoval?: string | null;
    /**
     * 
     * @type {LmCommunicationHistoryDto}
     * @memberof TransactionDetailsDto
     */
    lmCommunicationHistory?: LmCommunicationHistoryDto;
}
/**
 * 
 * @export
 * @interface TransactionDto
 */
export interface TransactionDto {
    /**
     * 
     * @type {number}
     * @memberof TransactionDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransactionDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    number?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransactionDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    currency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    method?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    direction?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionDto
     */
    reportedByUserId?: number;
    /**
     * 
     * @type {ApplicationUserMinimalDto}
     * @memberof TransactionDto
     */
    reportedByUser?: ApplicationUserMinimalDto;
    /**
     * 
     * @type {TransactionDto}
     * @memberof TransactionDto
     */
    parentTransaction?: TransactionDto;
    /**
     * 
     * @type {number}
     * @memberof TransactionDto
     */
    parentTransactionId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    bag?: string | null;
}
/**
 * 
 * @export
 * @interface TransactionExchangeReportDto
 */
export interface TransactionExchangeReportDto {
    /**
     * 
     * @type {number}
     * @memberof TransactionExchangeReportDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionExchangeReportDto
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionExchangeReportDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionExchangeReportDto
     */
    userId?: string | null;
}
/**
 * 
 * @export
 * @interface TransactionMinimalDto
 */
export interface TransactionMinimalDto {
    /**
     * 
     * @type {number}
     * @memberof TransactionMinimalDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionMinimalDto
     */
    reportedByUserId?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionMinimalDto
     */
    reportedByUsername?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionMinimalDto
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionMinimalDto
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionMinimalDto
     */
    direction?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransactionMinimalDto
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionMinimalDto
     */
    depositAmount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionMinimalDto
     */
    currency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionMinimalDto
     */
    userId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransactionMinimalDto
     */
    parentTransactionId?: number | null;
}
/**
 * 
 * @export
 * @interface TransactionSummaryDto
 */
export interface TransactionSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof TransactionSummaryDto
     */
    allTransactions?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummaryDto
     */
    depositCount?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummaryDto
     */
    cashOutCount?: number;
}
/**
 * 
 * @export
 * @interface TransactionUpdateDto
 */
export interface TransactionUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof TransactionUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransactionUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionUpdateDto
     */
    number?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransactionUpdateDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionUpdateDto
     */
    currency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionUpdateDto
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionUpdateDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionUpdateDto
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionUpdateDto
     */
    method?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionUpdateDto
     */
    direction?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionUpdateDto
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionUpdateDto
     */
    reportedByUserId?: number;
    /**
     * 
     * @type {ApplicationUserMinimalDto}
     * @memberof TransactionUpdateDto
     */
    reportedByUser?: ApplicationUserMinimalDto;
    /**
     * 
     * @type {TransactionDto}
     * @memberof TransactionUpdateDto
     */
    parentTransaction?: TransactionDto;
    /**
     * 
     * @type {number}
     * @memberof TransactionUpdateDto
     */
    parentTransactionId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionUpdateDto
     */
    bag?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionUpdateDto
     */
    originalFileContents?: string | null;
}
/**
 * 
 * @export
 * @interface TransactionWithCassetteDetailsDto
 */
export interface TransactionWithCassetteDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof TransactionWithCassetteDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionWithCassetteDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionWithCassetteDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionWithCassetteDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransactionWithCassetteDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionWithCassetteDetailsDto
     */
    number?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransactionWithCassetteDetailsDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionWithCassetteDetailsDto
     */
    currency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionWithCassetteDetailsDto
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionWithCassetteDetailsDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionWithCassetteDetailsDto
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionWithCassetteDetailsDto
     */
    method?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionWithCassetteDetailsDto
     */
    direction?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionWithCassetteDetailsDto
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionWithCassetteDetailsDto
     */
    reportedByUserId?: number;
    /**
     * 
     * @type {ApplicationUserMinimalDto}
     * @memberof TransactionWithCassetteDetailsDto
     */
    reportedByUser?: ApplicationUserMinimalDto;
    /**
     * 
     * @type {TransactionDto}
     * @memberof TransactionWithCassetteDetailsDto
     */
    parentTransaction?: TransactionDto;
    /**
     * 
     * @type {number}
     * @memberof TransactionWithCassetteDetailsDto
     */
    parentTransactionId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionWithCassetteDetailsDto
     */
    bag?: string | null;
    /**
     * 
     * @type {Array<CassetteContentDto>}
     * @memberof TransactionWithCassetteDetailsDto
     */
    cassetteContents?: Array<CassetteContentDto> | null;
}
/**
 * 
 * @export
 * @interface TransactionWithdrawalReportDto
 */
export interface TransactionWithdrawalReportDto {
    /**
     * 
     * @type {number}
     * @memberof TransactionWithdrawalReportDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionWithdrawalReportDto
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionWithdrawalReportDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionWithdrawalReportDto
     */
    userId?: string | null;
}

/**
 * ApplicationUserApi - axios parameter creator
 * @export
 */
export const ApplicationUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApplicationUserActivationDto} [applicationUserActivationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserActivatePost: async (applicationUserActivationDto?: ApplicationUserActivationDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/activate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applicationUserActivationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StartForgotPasswordDto} [startForgotPasswordDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserBeginForgotPasswordPost: async (startForgotPasswordDto?: StartForgotPasswordDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/beginForgotPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startForgotPasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [reportingDeviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserCashierSettlementGet: async (reportingDeviceId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/cashierSettlement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (reportingDeviceId !== undefined) {
                localVarQueryParameter['reportingDeviceId'] = reportingDeviceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [reportingUserId] 
         * @param {boolean} [notificationsEnabled] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserCassetteFillingNotificationStatePatch: async (reportingUserId?: number, notificationsEnabled?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/cassetteFillingNotificationState`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (reportingUserId !== undefined) {
                localVarQueryParameter['reportingUserId'] = reportingUserId;
            }

            if (notificationsEnabled !== undefined) {
                localVarQueryParameter['notificationsEnabled'] = notificationsEnabled;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ConfigurationDto} [configurationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserConfigurationPost: async (configurationDto?: ConfigurationDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configurationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [reportingUserId] 
         * @param {string} [selectedDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserDepositReportGet: async (reportingUserId?: number, selectedDate?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/depositReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (reportingUserId !== undefined) {
                localVarQueryParameter['reportingUserId'] = reportingUserId;
            }

            if (selectedDate !== undefined) {
                localVarQueryParameter['selectedDate'] = selectedDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [reportingUserId] 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserDeviceInactivityStatePatch: async (reportingUserId?: number, isActive?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/deviceInactivityState`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (reportingUserId !== undefined) {
                localVarQueryParameter['reportingUserId'] = reportingUserId;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['isActive'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EndForgotPasswordDto} [endForgotPasswordDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserEndForgotPasswordPost: async (endForgotPasswordDto?: EndForgotPasswordDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/endForgotPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(endForgotPasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiApplicationUserIdDelete', 'id', id)
            const localVarPath = `/api/ApplicationUser/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiApplicationUserIdGet', 'id', id)
            const localVarPath = `/api/ApplicationUser/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserIdPatch: async (id: number, applicationUserRegisterDto?: ApplicationUserRegisterDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiApplicationUserIdPatch', 'id', id)
            const localVarPath = `/api/ApplicationUser/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applicationUserRegisterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserIdPut: async (id: number, applicationUserRegisterDto?: ApplicationUserRegisterDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiApplicationUserIdPut', 'id', id)
            const localVarPath = `/api/ApplicationUser/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applicationUserRegisterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<ApplicationUserRole>} [applicationUserRole] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserIdRolesPost: async (id: number, applicationUserRole?: Array<ApplicationUserRole>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiApplicationUserIdRolesPost', 'id', id)
            const localVarPath = `/api/ApplicationUser/{id}/roles`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applicationUserRole, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [reportingDeviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserManagerCleaningGet: async (reportingDeviceId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/managerCleaning`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (reportingDeviceId !== undefined) {
                localVarQueryParameter['reportingDeviceId'] = reportingDeviceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [machineId] 
         * @param {ManualTransactionUploadDto} [manualTransactionUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserManualTransactionUploadPost: async (machineId?: number, manualTransactionUploadDto?: ManualTransactionUploadDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/manualTransactionUpload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (machineId !== undefined) {
                localVarQueryParameter['machineId'] = machineId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(manualTransactionUploadDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [reportingUserId] 
         * @param {boolean} [checkState] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserOfflineStatePatch: async (reportingUserId?: number, checkState?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/offlineState`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (reportingUserId !== undefined) {
                localVarQueryParameter['reportingUserId'] = reportingUserId;
            }

            if (checkState !== undefined) {
                localVarQueryParameter['checkState'] = checkState;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserPost: async (applicationUserRegisterDto?: ApplicationUserRegisterDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applicationUserRegisterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserReportingGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/reporting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserReportingIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiApplicationUserReportingIdGet', 'id', id)
            const localVarPath = `/api/ApplicationUser/reporting/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserReportingIdHistoryGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiApplicationUserReportingIdHistoryGet', 'id', id)
            const localVarPath = `/api/ApplicationUser/reporting/{id}/history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportingUserRegisterDto} [reportingUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserReportingPost: async (reportingUserRegisterDto?: ReportingUserRegisterDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/reporting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportingUserRegisterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {ReportingUserRegisterDto} [reportingUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserReportingPut: async (id?: number, reportingUserRegisterDto?: ReportingUserRegisterDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/reporting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportingUserRegisterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserReportingUserCassetteMappingsGet: async (userId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/reportingUserCassetteMappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserResendGet: async (email?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUserIdMinimalGet: async (userId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiApplicationUserUserIdMinimalGet', 'userId', userId)
            const localVarPath = `/api/ApplicationUser/{userId}/minimal`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApplicationUserApi - functional programming interface
 * @export
 */
export const ApplicationUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApplicationUserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApplicationUserActivationDto} [applicationUserActivationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserActivatePost(applicationUserActivationDto?: ApplicationUserActivationDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserActivatePost(applicationUserActivationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StartForgotPasswordDto} [startForgotPasswordDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserBeginForgotPasswordPost(startForgotPasswordDto?: StartForgotPasswordDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserBeginForgotPasswordPost(startForgotPasswordDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [reportingDeviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserCashierSettlementGet(reportingDeviceId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserCashierSettlementGet(reportingDeviceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [reportingUserId] 
         * @param {boolean} [notificationsEnabled] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserCassetteFillingNotificationStatePatch(reportingUserId?: number, notificationsEnabled?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserCassetteFillingNotificationStatePatch(reportingUserId, notificationsEnabled, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ConfigurationDto} [configurationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserConfigurationPost(configurationDto?: ConfigurationDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserConfigurationPost(configurationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [reportingUserId] 
         * @param {string} [selectedDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserDepositReportGet(reportingUserId?: number, selectedDate?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReportingUserDepositReportDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserDepositReportGet(reportingUserId, selectedDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [reportingUserId] 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserDeviceInactivityStatePatch(reportingUserId?: number, isActive?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserDeviceInactivityStatePatch(reportingUserId, isActive, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {EndForgotPasswordDto} [endForgotPasswordDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserEndForgotPasswordPost(endForgotPasswordDto?: EndForgotPasswordDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserEndForgotPasswordPost(endForgotPasswordDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationUserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationUserDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserIdPatch(id: number, applicationUserRegisterDto?: ApplicationUserRegisterDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationUserDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserIdPatch(id, applicationUserRegisterDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserIdPut(id: number, applicationUserRegisterDto?: ApplicationUserRegisterDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationUserDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserIdPut(id, applicationUserRegisterDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<ApplicationUserRole>} [applicationUserRole] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserIdRolesPost(id: number, applicationUserRole?: Array<ApplicationUserRole>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserIdRolesPost(id, applicationUserRole, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [reportingDeviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserManagerCleaningGet(reportingDeviceId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserManagerCleaningGet(reportingDeviceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [machineId] 
         * @param {ManualTransactionUploadDto} [manualTransactionUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserManualTransactionUploadPost(machineId?: number, manualTransactionUploadDto?: ManualTransactionUploadDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserManualTransactionUploadPost(machineId, manualTransactionUploadDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [reportingUserId] 
         * @param {boolean} [checkState] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserOfflineStatePatch(reportingUserId?: number, checkState?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserOfflineStatePatch(reportingUserId, checkState, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserPost(applicationUserRegisterDto?: ApplicationUserRegisterDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationUserDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserPost(applicationUserRegisterDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserReportingGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReportingUserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserReportingGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserReportingIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportingUserDetailsReducedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserReportingIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserReportingIdHistoryGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeviceHistoryEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserReportingIdHistoryGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportingUserRegisterDto} [reportingUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserReportingPost(reportingUserRegisterDto?: ReportingUserRegisterDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportingUserDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserReportingPost(reportingUserRegisterDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {ReportingUserRegisterDto} [reportingUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserReportingPut(id?: number, reportingUserRegisterDto?: ReportingUserRegisterDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserReportingPut(id, reportingUserRegisterDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserReportingUserCassetteMappingsGet(userId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationUserCassetteMappingsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserReportingUserCassetteMappingsGet(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserResendGet(email?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserResendGet(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserUserIdMinimalGet(userId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationUserMinimalDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserUserIdMinimalGet(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApplicationUserApi - factory interface
 * @export
 */
export const ApplicationUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApplicationUserApiFp(configuration)
    return {
        /**
         * 
         * @param {ApplicationUserActivationDto} [applicationUserActivationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserActivatePost(applicationUserActivationDto?: ApplicationUserActivationDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiApplicationUserActivatePost(applicationUserActivationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StartForgotPasswordDto} [startForgotPasswordDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserBeginForgotPasswordPost(startForgotPasswordDto?: StartForgotPasswordDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiApplicationUserBeginForgotPasswordPost(startForgotPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [reportingDeviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserCashierSettlementGet(reportingDeviceId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiApplicationUserCashierSettlementGet(reportingDeviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [reportingUserId] 
         * @param {boolean} [notificationsEnabled] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserCassetteFillingNotificationStatePatch(reportingUserId?: number, notificationsEnabled?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.apiApplicationUserCassetteFillingNotificationStatePatch(reportingUserId, notificationsEnabled, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConfigurationDto} [configurationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserConfigurationPost(configurationDto?: ConfigurationDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiApplicationUserConfigurationPost(configurationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [reportingUserId] 
         * @param {string} [selectedDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserDepositReportGet(reportingUserId?: number, selectedDate?: string, options?: any): AxiosPromise<Array<ReportingUserDepositReportDto>> {
            return localVarFp.apiApplicationUserDepositReportGet(reportingUserId, selectedDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [reportingUserId] 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserDeviceInactivityStatePatch(reportingUserId?: number, isActive?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.apiApplicationUserDeviceInactivityStatePatch(reportingUserId, isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EndForgotPasswordDto} [endForgotPasswordDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserEndForgotPasswordPost(endForgotPasswordDto?: EndForgotPasswordDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiApplicationUserEndForgotPasswordPost(endForgotPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserGet(options?: any): AxiosPromise<Array<ApplicationUserDto>> {
            return localVarFp.apiApplicationUserGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiApplicationUserIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserIdGet(id: number, options?: any): AxiosPromise<ApplicationUserDetailsDto> {
            return localVarFp.apiApplicationUserIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserIdPatch(id: number, applicationUserRegisterDto?: ApplicationUserRegisterDto, options?: any): AxiosPromise<ApplicationUserDetailsDto> {
            return localVarFp.apiApplicationUserIdPatch(id, applicationUserRegisterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserIdPut(id: number, applicationUserRegisterDto?: ApplicationUserRegisterDto, options?: any): AxiosPromise<ApplicationUserDetailsDto> {
            return localVarFp.apiApplicationUserIdPut(id, applicationUserRegisterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<ApplicationUserRole>} [applicationUserRole] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserIdRolesPost(id: number, applicationUserRole?: Array<ApplicationUserRole>, options?: any): AxiosPromise<void> {
            return localVarFp.apiApplicationUserIdRolesPost(id, applicationUserRole, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [reportingDeviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserManagerCleaningGet(reportingDeviceId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiApplicationUserManagerCleaningGet(reportingDeviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [machineId] 
         * @param {ManualTransactionUploadDto} [manualTransactionUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserManualTransactionUploadPost(machineId?: number, manualTransactionUploadDto?: ManualTransactionUploadDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiApplicationUserManualTransactionUploadPost(machineId, manualTransactionUploadDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [reportingUserId] 
         * @param {boolean} [checkState] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserOfflineStatePatch(reportingUserId?: number, checkState?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.apiApplicationUserOfflineStatePatch(reportingUserId, checkState, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserPost(applicationUserRegisterDto?: ApplicationUserRegisterDto, options?: any): AxiosPromise<ApplicationUserDetailsDto> {
            return localVarFp.apiApplicationUserPost(applicationUserRegisterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserReportingGet(options?: any): AxiosPromise<Array<ReportingUserDto>> {
            return localVarFp.apiApplicationUserReportingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserReportingIdGet(id: number, options?: any): AxiosPromise<ReportingUserDetailsReducedDto> {
            return localVarFp.apiApplicationUserReportingIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserReportingIdHistoryGet(id: number, options?: any): AxiosPromise<Array<DeviceHistoryEventDto>> {
            return localVarFp.apiApplicationUserReportingIdHistoryGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportingUserRegisterDto} [reportingUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserReportingPost(reportingUserRegisterDto?: ReportingUserRegisterDto, options?: any): AxiosPromise<ReportingUserDetailsDto> {
            return localVarFp.apiApplicationUserReportingPost(reportingUserRegisterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [id] 
         * @param {ReportingUserRegisterDto} [reportingUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserReportingPut(id?: number, reportingUserRegisterDto?: ReportingUserRegisterDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiApplicationUserReportingPut(id, reportingUserRegisterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserReportingUserCassetteMappingsGet(userId?: number, options?: any): AxiosPromise<Array<ApplicationUserCassetteMappingsDto>> {
            return localVarFp.apiApplicationUserReportingUserCassetteMappingsGet(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserResendGet(email?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiApplicationUserResendGet(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUserIdMinimalGet(userId: number, options?: any): AxiosPromise<ApplicationUserMinimalDto> {
            return localVarFp.apiApplicationUserUserIdMinimalGet(userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApplicationUserApi - object-oriented interface
 * @export
 * @class ApplicationUserApi
 * @extends {BaseAPI}
 */
export class ApplicationUserApi extends BaseAPI {
    /**
     * 
     * @param {ApplicationUserActivationDto} [applicationUserActivationDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserActivatePost(applicationUserActivationDto?: ApplicationUserActivationDto, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserActivatePost(applicationUserActivationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StartForgotPasswordDto} [startForgotPasswordDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserBeginForgotPasswordPost(startForgotPasswordDto?: StartForgotPasswordDto, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserBeginForgotPasswordPost(startForgotPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [reportingDeviceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserCashierSettlementGet(reportingDeviceId?: number, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserCashierSettlementGet(reportingDeviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [reportingUserId] 
     * @param {boolean} [notificationsEnabled] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserCassetteFillingNotificationStatePatch(reportingUserId?: number, notificationsEnabled?: boolean, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserCassetteFillingNotificationStatePatch(reportingUserId, notificationsEnabled, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConfigurationDto} [configurationDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserConfigurationPost(configurationDto?: ConfigurationDto, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserConfigurationPost(configurationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [reportingUserId] 
     * @param {string} [selectedDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserDepositReportGet(reportingUserId?: number, selectedDate?: string, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserDepositReportGet(reportingUserId, selectedDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [reportingUserId] 
     * @param {boolean} [isActive] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserDeviceInactivityStatePatch(reportingUserId?: number, isActive?: boolean, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserDeviceInactivityStatePatch(reportingUserId, isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EndForgotPasswordDto} [endForgotPasswordDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserEndForgotPasswordPost(endForgotPasswordDto?: EndForgotPasswordDto, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserEndForgotPasswordPost(endForgotPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserGet(options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserIdDelete(id: number, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserIdGet(id: number, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserIdPatch(id: number, applicationUserRegisterDto?: ApplicationUserRegisterDto, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserIdPatch(id, applicationUserRegisterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserIdPut(id: number, applicationUserRegisterDto?: ApplicationUserRegisterDto, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserIdPut(id, applicationUserRegisterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {Array<ApplicationUserRole>} [applicationUserRole] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserIdRolesPost(id: number, applicationUserRole?: Array<ApplicationUserRole>, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserIdRolesPost(id, applicationUserRole, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [reportingDeviceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserManagerCleaningGet(reportingDeviceId?: number, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserManagerCleaningGet(reportingDeviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [machineId] 
     * @param {ManualTransactionUploadDto} [manualTransactionUploadDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserManualTransactionUploadPost(machineId?: number, manualTransactionUploadDto?: ManualTransactionUploadDto, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserManualTransactionUploadPost(machineId, manualTransactionUploadDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [reportingUserId] 
     * @param {boolean} [checkState] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserOfflineStatePatch(reportingUserId?: number, checkState?: boolean, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserOfflineStatePatch(reportingUserId, checkState, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserPost(applicationUserRegisterDto?: ApplicationUserRegisterDto, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserPost(applicationUserRegisterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserReportingGet(options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserReportingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserReportingIdGet(id: number, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserReportingIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserReportingIdHistoryGet(id: number, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserReportingIdHistoryGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportingUserRegisterDto} [reportingUserRegisterDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserReportingPost(reportingUserRegisterDto?: ReportingUserRegisterDto, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserReportingPost(reportingUserRegisterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [id] 
     * @param {ReportingUserRegisterDto} [reportingUserRegisterDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserReportingPut(id?: number, reportingUserRegisterDto?: ReportingUserRegisterDto, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserReportingPut(id, reportingUserRegisterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserReportingUserCassetteMappingsGet(userId?: number, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserReportingUserCassetteMappingsGet(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserResendGet(email?: string, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserResendGet(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserUserIdMinimalGet(userId: number, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserUserIdMinimalGet(userId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [returnUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationLoginCallbackGet: async (returnUrl?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Authentication/loginCallback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (returnUrl !== undefined) {
                localVarQueryParameter['returnUrl'] = returnUrl;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [loginPageUrl] 
         * @param {string} [returnUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationLoginGet: async (loginPageUrl?: string, returnUrl?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Authentication/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (loginPageUrl !== undefined) {
                localVarQueryParameter['loginPageUrl'] = loginPageUrl;
            }

            if (returnUrl !== undefined) {
                localVarQueryParameter['returnUrl'] = returnUrl;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [returnUrl] 
         * @param {LoginDto} [loginDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationLoginPost: async (returnUrl?: string, loginDto?: LoginDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Authentication/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (returnUrl !== undefined) {
                localVarQueryParameter['returnUrl'] = returnUrl;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [postLogoutUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationLogoutGet: async (postLogoutUrl?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Authentication/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (postLogoutUrl !== undefined) {
                localVarQueryParameter['postLogoutUrl'] = postLogoutUrl;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [returnUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationLoginCallbackGet(returnUrl?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationLoginCallbackGet(returnUrl, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [loginPageUrl] 
         * @param {string} [returnUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationLoginGet(loginPageUrl?: string, returnUrl?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationLoginGet(loginPageUrl, returnUrl, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [returnUrl] 
         * @param {LoginDto} [loginDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationLoginPost(returnUrl?: string, loginDto?: LoginDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationLoginPost(returnUrl, loginDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [postLogoutUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationLogoutGet(postLogoutUrl?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationLogoutGet(postLogoutUrl, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [returnUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationLoginCallbackGet(returnUrl?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAuthenticationLoginCallbackGet(returnUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [loginPageUrl] 
         * @param {string} [returnUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationLoginGet(loginPageUrl?: string, returnUrl?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAuthenticationLoginGet(loginPageUrl, returnUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [returnUrl] 
         * @param {LoginDto} [loginDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationLoginPost(returnUrl?: string, loginDto?: LoginDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiAuthenticationLoginPost(returnUrl, loginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [postLogoutUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationLogoutGet(postLogoutUrl?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAuthenticationLogoutGet(postLogoutUrl, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * 
     * @param {string} [returnUrl] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public apiAuthenticationLoginCallbackGet(returnUrl?: string, options?: any) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationLoginCallbackGet(returnUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [loginPageUrl] 
     * @param {string} [returnUrl] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public apiAuthenticationLoginGet(loginPageUrl?: string, returnUrl?: string, options?: any) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationLoginGet(loginPageUrl, returnUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [returnUrl] 
     * @param {LoginDto} [loginDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public apiAuthenticationLoginPost(returnUrl?: string, loginDto?: LoginDto, options?: any) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationLoginPost(returnUrl, loginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [postLogoutUrl] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public apiAuthenticationLogoutGet(postLogoutUrl?: string, options?: any) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationLogoutGet(postLogoutUrl, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LmCommunicationHistoryApi - axios parameter creator
 * @export
 */
export const LmCommunicationHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLmCommunicationHistoryAvailabilityGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/LmCommunicationHistory/availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLmCommunicationHistoryConfigurationGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/LmCommunicationHistory/configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [deviceId] 
         * @param {number} [startTimeStamp] 
         * @param {number} [endTimeStamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLmCommunicationHistoryDeviceHistoryGet: async (deviceId?: number, startTimeStamp?: number, endTimeStamp?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/LmCommunicationHistory/deviceHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }

            if (startTimeStamp !== undefined) {
                localVarQueryParameter['startTimeStamp'] = startTimeStamp;
            }

            if (endTimeStamp !== undefined) {
                localVarQueryParameter['endTimeStamp'] = endTimeStamp;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [startTimeStamp] 
         * @param {number} [endTimeStamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLmCommunicationHistoryGet: async (startTimeStamp?: number, endTimeStamp?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/LmCommunicationHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (startTimeStamp !== undefined) {
                localVarQueryParameter['startTimeStamp'] = startTimeStamp;
            }

            if (endTimeStamp !== undefined) {
                localVarQueryParameter['endTimeStamp'] = endTimeStamp;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLmCommunicationHistoryIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiLmCommunicationHistoryIdGet', 'id', id)
            const localVarPath = `/api/LmCommunicationHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLmCommunicationHistoryLmCommunicationSettingsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/LmCommunicationHistory/LmCommunicationSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLmCommunicationHistoryLmCommunicationSettingsHistoryGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/LmCommunicationHistory/LmCommunicationSettings/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLmCommunicationHistoryLmCommunicationSettingsHistoryUserIdGet: async (userId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiLmCommunicationHistoryLmCommunicationSettingsHistoryUserIdGet', 'userId', userId)
            const localVarPath = `/api/LmCommunicationHistory/LmCommunicationSettings/history/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LmCommunicationSettingsUpdateDto} [lmCommunicationSettingsUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLmCommunicationHistoryLmCommunicationSettingsPatch: async (lmCommunicationSettingsUpdateDto?: LmCommunicationSettingsUpdateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/LmCommunicationHistory/LmCommunicationSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lmCommunicationSettingsUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLmCommunicationHistoryResendPost: async (id?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/LmCommunicationHistory/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LmCommunicationHistoryApi - functional programming interface
 * @export
 */
export const LmCommunicationHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LmCommunicationHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLmCommunicationHistoryAvailabilityGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LmServerAvailabilityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLmCommunicationHistoryAvailabilityGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLmCommunicationHistoryConfigurationGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LmCommunicationConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLmCommunicationHistoryConfigurationGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [deviceId] 
         * @param {number} [startTimeStamp] 
         * @param {number} [endTimeStamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLmCommunicationHistoryDeviceHistoryGet(deviceId?: number, startTimeStamp?: number, endTimeStamp?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LmCommunicationHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLmCommunicationHistoryDeviceHistoryGet(deviceId, startTimeStamp, endTimeStamp, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [startTimeStamp] 
         * @param {number} [endTimeStamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLmCommunicationHistoryGet(startTimeStamp?: number, endTimeStamp?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LmCommunicationHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLmCommunicationHistoryGet(startTimeStamp, endTimeStamp, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLmCommunicationHistoryIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LmCommunicationHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLmCommunicationHistoryIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLmCommunicationHistoryLmCommunicationSettingsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LmCommunicationSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLmCommunicationHistoryLmCommunicationSettingsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLmCommunicationHistoryLmCommunicationSettingsHistoryGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LmCommunicationSettingsHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLmCommunicationHistoryLmCommunicationSettingsHistoryGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLmCommunicationHistoryLmCommunicationSettingsHistoryUserIdGet(userId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LmCommunicationSettingsHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLmCommunicationHistoryLmCommunicationSettingsHistoryUserIdGet(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LmCommunicationSettingsUpdateDto} [lmCommunicationSettingsUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLmCommunicationHistoryLmCommunicationSettingsPatch(lmCommunicationSettingsUpdateDto?: LmCommunicationSettingsUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLmCommunicationHistoryLmCommunicationSettingsPatch(lmCommunicationSettingsUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLmCommunicationHistoryResendPost(id?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLmCommunicationHistoryResendPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LmCommunicationHistoryApi - factory interface
 * @export
 */
export const LmCommunicationHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LmCommunicationHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLmCommunicationHistoryAvailabilityGet(options?: any): AxiosPromise<LmServerAvailabilityDto> {
            return localVarFp.apiLmCommunicationHistoryAvailabilityGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLmCommunicationHistoryConfigurationGet(options?: any): AxiosPromise<LmCommunicationConfigurationDto> {
            return localVarFp.apiLmCommunicationHistoryConfigurationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [deviceId] 
         * @param {number} [startTimeStamp] 
         * @param {number} [endTimeStamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLmCommunicationHistoryDeviceHistoryGet(deviceId?: number, startTimeStamp?: number, endTimeStamp?: number, options?: any): AxiosPromise<Array<LmCommunicationHistoryDto>> {
            return localVarFp.apiLmCommunicationHistoryDeviceHistoryGet(deviceId, startTimeStamp, endTimeStamp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [startTimeStamp] 
         * @param {number} [endTimeStamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLmCommunicationHistoryGet(startTimeStamp?: number, endTimeStamp?: number, options?: any): AxiosPromise<Array<LmCommunicationHistoryDto>> {
            return localVarFp.apiLmCommunicationHistoryGet(startTimeStamp, endTimeStamp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLmCommunicationHistoryIdGet(id: number, options?: any): AxiosPromise<LmCommunicationHistoryDetailsDto> {
            return localVarFp.apiLmCommunicationHistoryIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLmCommunicationHistoryLmCommunicationSettingsGet(options?: any): AxiosPromise<LmCommunicationSettingsDto> {
            return localVarFp.apiLmCommunicationHistoryLmCommunicationSettingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLmCommunicationHistoryLmCommunicationSettingsHistoryGet(options?: any): AxiosPromise<Array<LmCommunicationSettingsHistoryDto>> {
            return localVarFp.apiLmCommunicationHistoryLmCommunicationSettingsHistoryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLmCommunicationHistoryLmCommunicationSettingsHistoryUserIdGet(userId: number, options?: any): AxiosPromise<Array<LmCommunicationSettingsHistoryDto>> {
            return localVarFp.apiLmCommunicationHistoryLmCommunicationSettingsHistoryUserIdGet(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LmCommunicationSettingsUpdateDto} [lmCommunicationSettingsUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLmCommunicationHistoryLmCommunicationSettingsPatch(lmCommunicationSettingsUpdateDto?: LmCommunicationSettingsUpdateDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiLmCommunicationHistoryLmCommunicationSettingsPatch(lmCommunicationSettingsUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLmCommunicationHistoryResendPost(id?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiLmCommunicationHistoryResendPost(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LmCommunicationHistoryApi - object-oriented interface
 * @export
 * @class LmCommunicationHistoryApi
 * @extends {BaseAPI}
 */
export class LmCommunicationHistoryApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LmCommunicationHistoryApi
     */
    public apiLmCommunicationHistoryAvailabilityGet(options?: any) {
        return LmCommunicationHistoryApiFp(this.configuration).apiLmCommunicationHistoryAvailabilityGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LmCommunicationHistoryApi
     */
    public apiLmCommunicationHistoryConfigurationGet(options?: any) {
        return LmCommunicationHistoryApiFp(this.configuration).apiLmCommunicationHistoryConfigurationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [deviceId] 
     * @param {number} [startTimeStamp] 
     * @param {number} [endTimeStamp] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LmCommunicationHistoryApi
     */
    public apiLmCommunicationHistoryDeviceHistoryGet(deviceId?: number, startTimeStamp?: number, endTimeStamp?: number, options?: any) {
        return LmCommunicationHistoryApiFp(this.configuration).apiLmCommunicationHistoryDeviceHistoryGet(deviceId, startTimeStamp, endTimeStamp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [startTimeStamp] 
     * @param {number} [endTimeStamp] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LmCommunicationHistoryApi
     */
    public apiLmCommunicationHistoryGet(startTimeStamp?: number, endTimeStamp?: number, options?: any) {
        return LmCommunicationHistoryApiFp(this.configuration).apiLmCommunicationHistoryGet(startTimeStamp, endTimeStamp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LmCommunicationHistoryApi
     */
    public apiLmCommunicationHistoryIdGet(id: number, options?: any) {
        return LmCommunicationHistoryApiFp(this.configuration).apiLmCommunicationHistoryIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LmCommunicationHistoryApi
     */
    public apiLmCommunicationHistoryLmCommunicationSettingsGet(options?: any) {
        return LmCommunicationHistoryApiFp(this.configuration).apiLmCommunicationHistoryLmCommunicationSettingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LmCommunicationHistoryApi
     */
    public apiLmCommunicationHistoryLmCommunicationSettingsHistoryGet(options?: any) {
        return LmCommunicationHistoryApiFp(this.configuration).apiLmCommunicationHistoryLmCommunicationSettingsHistoryGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LmCommunicationHistoryApi
     */
    public apiLmCommunicationHistoryLmCommunicationSettingsHistoryUserIdGet(userId: number, options?: any) {
        return LmCommunicationHistoryApiFp(this.configuration).apiLmCommunicationHistoryLmCommunicationSettingsHistoryUserIdGet(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LmCommunicationSettingsUpdateDto} [lmCommunicationSettingsUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LmCommunicationHistoryApi
     */
    public apiLmCommunicationHistoryLmCommunicationSettingsPatch(lmCommunicationSettingsUpdateDto?: LmCommunicationSettingsUpdateDto, options?: any) {
        return LmCommunicationHistoryApiFp(this.configuration).apiLmCommunicationHistoryLmCommunicationSettingsPatch(lmCommunicationSettingsUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LmCommunicationHistoryApi
     */
    public apiLmCommunicationHistoryResendPost(id?: number, options?: any) {
        return LmCommunicationHistoryApiFp(this.configuration).apiLmCommunicationHistoryResendPost(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LogApi - axios parameter creator
 * @export
 */
export const LogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [deviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogDeviceLogsGet: async (deviceId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Log/deviceLogs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogFileIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiLogFileIdGet', 'id', id)
            const localVarPath = `/api/Log/file/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Log`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiLogIdGet', 'id', id)
            const localVarPath = `/api/Log/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LogApi - functional programming interface
 * @export
 */
export const LogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [deviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogDeviceLogsGet(deviceId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LogDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogDeviceLogsGet(deviceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogFileIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogFileIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LogDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LogApi - factory interface
 * @export
 */
export const LogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LogApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [deviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogDeviceLogsGet(deviceId?: number, options?: any): AxiosPromise<Array<LogDto>> {
            return localVarFp.apiLogDeviceLogsGet(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogFileIdGet(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiLogFileIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogGet(options?: any): AxiosPromise<Array<LogDto>> {
            return localVarFp.apiLogGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogIdGet(id: number, options?: any): AxiosPromise<LogDetailsDto> {
            return localVarFp.apiLogIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LogApi - object-oriented interface
 * @export
 * @class LogApi
 * @extends {BaseAPI}
 */
export class LogApi extends BaseAPI {
    /**
     * 
     * @param {number} [deviceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogApi
     */
    public apiLogDeviceLogsGet(deviceId?: number, options?: any) {
        return LogApiFp(this.configuration).apiLogDeviceLogsGet(deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogApi
     */
    public apiLogFileIdGet(id: number, options?: any) {
        return LogApiFp(this.configuration).apiLogFileIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogApi
     */
    public apiLogGet(options?: any) {
        return LogApiFp(this.configuration).apiLogGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogApi
     */
    public apiLogIdGet(id: number, options?: any) {
        return LogApiFp(this.configuration).apiLogIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SummaryApi - axios parameter creator
 * @export
 */
export const SummaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSummaryGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SummaryApi - functional programming interface
 * @export
 */
export const SummaryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SummaryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSummaryGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSummaryGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SummaryApi - factory interface
 * @export
 */
export const SummaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SummaryApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSummaryGet(options?: any): AxiosPromise<SummaryDto> {
            return localVarFp.apiSummaryGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SummaryApi - object-oriented interface
 * @export
 * @class SummaryApi
 * @extends {BaseAPI}
 */
export class SummaryApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SummaryApi
     */
    public apiSummaryGet(options?: any) {
        return SummaryApiFp(this.configuration).apiSummaryGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TransactionApi - axios parameter creator
 * @export
 */
export const TransactionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [reportingUserId] 
         * @param {number} [startTimeStamp] 
         * @param {number} [endTimeStamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionCashRemovalReportGet: async (reportingUserId?: number, startTimeStamp?: number, endTimeStamp?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Transaction/cashRemovalReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (reportingUserId !== undefined) {
                localVarQueryParameter['reportingUserId'] = reportingUserId;
            }

            if (startTimeStamp !== undefined) {
                localVarQueryParameter['startTimeStamp'] = startTimeStamp;
            }

            if (endTimeStamp !== undefined) {
                localVarQueryParameter['endTimeStamp'] = endTimeStamp;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [deviceId] 
         * @param {number} [startTimeStamp] 
         * @param {number} [endTimeStamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionExchangeReportGet: async (deviceId?: number, startTimeStamp?: number, endTimeStamp?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Transaction/exchangeReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }

            if (startTimeStamp !== undefined) {
                localVarQueryParameter['startTimeStamp'] = startTimeStamp;
            }

            if (endTimeStamp !== undefined) {
                localVarQueryParameter['endTimeStamp'] = endTimeStamp;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [startTimeStamp] 
         * @param {number} [endTimeStamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionFilteredGet: async (startTimeStamp?: number, endTimeStamp?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Transaction/filtered`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (startTimeStamp !== undefined) {
                localVarQueryParameter['startTimeStamp'] = startTimeStamp;
            }

            if (endTimeStamp !== undefined) {
                localVarQueryParameter['endTimeStamp'] = endTimeStamp;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Transaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTransactionIdDelete', 'id', id)
            const localVarPath = `/api/Transaction/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTransactionIdGet', 'id', id)
            const localVarPath = `/api/Transaction/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {TransactionUpdateDto} [transactionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionIdPatch: async (id: number, transactionUpdateDto?: TransactionUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTransactionIdPatch', 'id', id)
            const localVarPath = `/api/Transaction/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transactionUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {TransactionUpdateDto} [transactionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionIdPut: async (id: number, transactionUpdateDto?: TransactionUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTransactionIdPut', 'id', id)
            const localVarPath = `/api/Transaction/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transactionUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionOriginalGet: async (id?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Transaction/original`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TransactionCreateDto} [transactionCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionPost: async (transactionCreateDto?: TransactionCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Transaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transactionCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} reportingUserId 
         * @param {number} [startTimeStamp] 
         * @param {number} [endTimeStamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionReportingUserReportingUserIdGet: async (reportingUserId: number, startTimeStamp?: number, endTimeStamp?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportingUserId' is not null or undefined
            assertParamExists('apiTransactionReportingUserReportingUserIdGet', 'reportingUserId', reportingUserId)
            const localVarPath = `/api/Transaction/reportingUser/{reportingUserId}`
                .replace(`{${"reportingUserId"}}`, encodeURIComponent(String(reportingUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (startTimeStamp !== undefined) {
                localVarQueryParameter['startTimeStamp'] = startTimeStamp;
            }

            if (endTimeStamp !== undefined) {
                localVarQueryParameter['endTimeStamp'] = endTimeStamp;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [parentTransactionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionSubTransactionsGet: async (parentTransactionId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Transaction/subTransactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (parentTransactionId !== undefined) {
                localVarQueryParameter['parentTransactionId'] = parentTransactionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [deviceId] 
         * @param {number} [startTimeStamp] 
         * @param {number} [endTimeStamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionWithdrawalReportGet: async (deviceId?: number, startTimeStamp?: number, endTimeStamp?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Transaction/withdrawalReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }

            if (startTimeStamp !== undefined) {
                localVarQueryParameter['startTimeStamp'] = startTimeStamp;
            }

            if (endTimeStamp !== undefined) {
                localVarQueryParameter['endTimeStamp'] = endTimeStamp;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransactionApi - functional programming interface
 * @export
 */
export const TransactionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransactionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [reportingUserId] 
         * @param {number} [startTimeStamp] 
         * @param {number} [endTimeStamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTransactionCashRemovalReportGet(reportingUserId?: number, startTimeStamp?: number, endTimeStamp?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransactionCashRemovalReportDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTransactionCashRemovalReportGet(reportingUserId, startTimeStamp, endTimeStamp, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [deviceId] 
         * @param {number} [startTimeStamp] 
         * @param {number} [endTimeStamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTransactionExchangeReportGet(deviceId?: number, startTimeStamp?: number, endTimeStamp?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransactionExchangeReportDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTransactionExchangeReportGet(deviceId, startTimeStamp, endTimeStamp, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [startTimeStamp] 
         * @param {number} [endTimeStamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTransactionFilteredGet(startTimeStamp?: number, endTimeStamp?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransactionMinimalDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTransactionFilteredGet(startTimeStamp, endTimeStamp, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTransactionGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransactionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTransactionGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTransactionIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTransactionIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTransactionIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTransactionIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {TransactionUpdateDto} [transactionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTransactionIdPatch(id: number, transactionUpdateDto?: TransactionUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTransactionIdPatch(id, transactionUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {TransactionUpdateDto} [transactionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTransactionIdPut(id: number, transactionUpdateDto?: TransactionUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTransactionIdPut(id, transactionUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTransactionOriginalGet(id?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTransactionOriginalGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TransactionCreateDto} [transactionCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTransactionPost(transactionCreateDto?: TransactionCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTransactionPost(transactionCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} reportingUserId 
         * @param {number} [startTimeStamp] 
         * @param {number} [endTimeStamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTransactionReportingUserReportingUserIdGet(reportingUserId: number, startTimeStamp?: number, endTimeStamp?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransactionMinimalDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTransactionReportingUserReportingUserIdGet(reportingUserId, startTimeStamp, endTimeStamp, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [parentTransactionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTransactionSubTransactionsGet(parentTransactionId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransactionDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTransactionSubTransactionsGet(parentTransactionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [deviceId] 
         * @param {number} [startTimeStamp] 
         * @param {number} [endTimeStamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTransactionWithdrawalReportGet(deviceId?: number, startTimeStamp?: number, endTimeStamp?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransactionWithdrawalReportDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTransactionWithdrawalReportGet(deviceId, startTimeStamp, endTimeStamp, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TransactionApi - factory interface
 * @export
 */
export const TransactionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransactionApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [reportingUserId] 
         * @param {number} [startTimeStamp] 
         * @param {number} [endTimeStamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionCashRemovalReportGet(reportingUserId?: number, startTimeStamp?: number, endTimeStamp?: number, options?: any): AxiosPromise<Array<TransactionCashRemovalReportDto>> {
            return localVarFp.apiTransactionCashRemovalReportGet(reportingUserId, startTimeStamp, endTimeStamp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [deviceId] 
         * @param {number} [startTimeStamp] 
         * @param {number} [endTimeStamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionExchangeReportGet(deviceId?: number, startTimeStamp?: number, endTimeStamp?: number, options?: any): AxiosPromise<Array<TransactionExchangeReportDto>> {
            return localVarFp.apiTransactionExchangeReportGet(deviceId, startTimeStamp, endTimeStamp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [startTimeStamp] 
         * @param {number} [endTimeStamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionFilteredGet(startTimeStamp?: number, endTimeStamp?: number, options?: any): AxiosPromise<Array<TransactionMinimalDto>> {
            return localVarFp.apiTransactionFilteredGet(startTimeStamp, endTimeStamp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionGet(options?: any): AxiosPromise<Array<TransactionDto>> {
            return localVarFp.apiTransactionGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiTransactionIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionIdGet(id: number, options?: any): AxiosPromise<TransactionDetailsDto> {
            return localVarFp.apiTransactionIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {TransactionUpdateDto} [transactionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionIdPatch(id: number, transactionUpdateDto?: TransactionUpdateDto, options?: any): AxiosPromise<TransactionDetailsDto> {
            return localVarFp.apiTransactionIdPatch(id, transactionUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {TransactionUpdateDto} [transactionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionIdPut(id: number, transactionUpdateDto?: TransactionUpdateDto, options?: any): AxiosPromise<TransactionDetailsDto> {
            return localVarFp.apiTransactionIdPut(id, transactionUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionOriginalGet(id?: number, options?: any): AxiosPromise<string> {
            return localVarFp.apiTransactionOriginalGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TransactionCreateDto} [transactionCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionPost(transactionCreateDto?: TransactionCreateDto, options?: any): AxiosPromise<TransactionDetailsDto> {
            return localVarFp.apiTransactionPost(transactionCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} reportingUserId 
         * @param {number} [startTimeStamp] 
         * @param {number} [endTimeStamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionReportingUserReportingUserIdGet(reportingUserId: number, startTimeStamp?: number, endTimeStamp?: number, options?: any): AxiosPromise<Array<TransactionMinimalDto>> {
            return localVarFp.apiTransactionReportingUserReportingUserIdGet(reportingUserId, startTimeStamp, endTimeStamp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [parentTransactionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionSubTransactionsGet(parentTransactionId?: number, options?: any): AxiosPromise<Array<TransactionDetailsDto>> {
            return localVarFp.apiTransactionSubTransactionsGet(parentTransactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [deviceId] 
         * @param {number} [startTimeStamp] 
         * @param {number} [endTimeStamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTransactionWithdrawalReportGet(deviceId?: number, startTimeStamp?: number, endTimeStamp?: number, options?: any): AxiosPromise<Array<TransactionWithdrawalReportDto>> {
            return localVarFp.apiTransactionWithdrawalReportGet(deviceId, startTimeStamp, endTimeStamp, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TransactionApi - object-oriented interface
 * @export
 * @class TransactionApi
 * @extends {BaseAPI}
 */
export class TransactionApi extends BaseAPI {
    /**
     * 
     * @param {number} [reportingUserId] 
     * @param {number} [startTimeStamp] 
     * @param {number} [endTimeStamp] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public apiTransactionCashRemovalReportGet(reportingUserId?: number, startTimeStamp?: number, endTimeStamp?: number, options?: any) {
        return TransactionApiFp(this.configuration).apiTransactionCashRemovalReportGet(reportingUserId, startTimeStamp, endTimeStamp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [deviceId] 
     * @param {number} [startTimeStamp] 
     * @param {number} [endTimeStamp] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public apiTransactionExchangeReportGet(deviceId?: number, startTimeStamp?: number, endTimeStamp?: number, options?: any) {
        return TransactionApiFp(this.configuration).apiTransactionExchangeReportGet(deviceId, startTimeStamp, endTimeStamp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [startTimeStamp] 
     * @param {number} [endTimeStamp] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public apiTransactionFilteredGet(startTimeStamp?: number, endTimeStamp?: number, options?: any) {
        return TransactionApiFp(this.configuration).apiTransactionFilteredGet(startTimeStamp, endTimeStamp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public apiTransactionGet(options?: any) {
        return TransactionApiFp(this.configuration).apiTransactionGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public apiTransactionIdDelete(id: number, options?: any) {
        return TransactionApiFp(this.configuration).apiTransactionIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public apiTransactionIdGet(id: number, options?: any) {
        return TransactionApiFp(this.configuration).apiTransactionIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {TransactionUpdateDto} [transactionUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public apiTransactionIdPatch(id: number, transactionUpdateDto?: TransactionUpdateDto, options?: any) {
        return TransactionApiFp(this.configuration).apiTransactionIdPatch(id, transactionUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {TransactionUpdateDto} [transactionUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public apiTransactionIdPut(id: number, transactionUpdateDto?: TransactionUpdateDto, options?: any) {
        return TransactionApiFp(this.configuration).apiTransactionIdPut(id, transactionUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public apiTransactionOriginalGet(id?: number, options?: any) {
        return TransactionApiFp(this.configuration).apiTransactionOriginalGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TransactionCreateDto} [transactionCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public apiTransactionPost(transactionCreateDto?: TransactionCreateDto, options?: any) {
        return TransactionApiFp(this.configuration).apiTransactionPost(transactionCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} reportingUserId 
     * @param {number} [startTimeStamp] 
     * @param {number} [endTimeStamp] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public apiTransactionReportingUserReportingUserIdGet(reportingUserId: number, startTimeStamp?: number, endTimeStamp?: number, options?: any) {
        return TransactionApiFp(this.configuration).apiTransactionReportingUserReportingUserIdGet(reportingUserId, startTimeStamp, endTimeStamp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [parentTransactionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public apiTransactionSubTransactionsGet(parentTransactionId?: number, options?: any) {
        return TransactionApiFp(this.configuration).apiTransactionSubTransactionsGet(parentTransactionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [deviceId] 
     * @param {number} [startTimeStamp] 
     * @param {number} [endTimeStamp] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public apiTransactionWithdrawalReportGet(deviceId?: number, startTimeStamp?: number, endTimeStamp?: number, options?: any) {
        return TransactionApiFp(this.configuration).apiTransactionWithdrawalReportGet(deviceId, startTimeStamp, endTimeStamp, options).then((request) => request(this.axios, this.basePath));
    }
}


